<template>
  <header class="d-flex justify-content-between align-items-center">
    <label for="toggle-1" class="toggle-menu" @click="toggleMenu">
      <ul>
        <li></li>
        <li></li>
        <li></li>
      </ul>
    </label>
    <!-- <strong @click="toggleMenu"> &#9776;	</strong> -->
    <nav class="nav_center" style="padding: 0" :style="{ display: isMenuVisible ? 'block' : 'none' }">
      <ul style="list-style: none">
        <li :class="{ topmenuactive: activeTab === 'gioiThieu' }" @click="changeTab('gioiThieu')" style="display: none;">
          <a id="urlCTThiDiem">{{ currentLanguage.header_text_gioiThieu }}
          </a>
        </li>

        <li :class="{ topmenuactive: activeTab === 'taiTro' }" @click="changeTab('taiTro')" >
          <a id="urlCTTaiTro" style=" color: black; display: none;">{{ currentLanguage.header_text_thietbithietyeu }}
          </a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'BenhVienTinh' }" @click="changeTab('BenhVienTinh')"
          style="display: none;">
          <a id="urlBenhVienTinh" style=" color: black;">{{
            currentLanguage.header_text_theDaNang_TCNguoiNgheo_Tinhthanhpho
          }}</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'BenhVienHuyen' }" @click="changeTab('BenhVienHuyen')"
          style="display: none;">
          <a id="urlBenhVienHuyen" style=" color: black;">{{
            currentLanguage.header_text_theDaNang_QuanHuyen
          }}</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'ThietBi' }" @click="changeTab('ThietBi')">
          <a id="urlThietBi">{{
            currentLanguage.header_text_sanPham
          }}</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'DichVu' }" @click="changeTab('DichVu')" style="display: none;" >
          <a id="urlDichVu">{{ currentLanguage.footer_text_dichVu }}</a>
        </li>
      
      </ul>
    </nav>
    <div class="menu_right" style="display: flex">
      <div class="menu_co_right" style="display: flex">
        <a @click="changeLanguage('vi')" class="lang" style="padding: 5px"><img
            src="img/img-item-vimass-2022/co/vi-VN.gif" />
        </a>
        <a @click="changeLanguage('en')" class="lang" style="padding: 5px"><img style="width: 25px"
            src="img/img-item-vimass-2022/co/us.png" />
        </a>
        <a @click="changeLanguage('cn')" class="lang d-none" style="padding: 5px"><img style="width: 25px"
            src="img/img-item-vimass-2022/co/cn.jpg" />
        </a>
        <a @click="changeLanguage('kr')" class="lang d-none" style="padding: 5px"><img style="width: 25px ; "
            src="img/img-item-vimass-2022/co/kr.jpg" />
        </a>

        <a @click="changeLanguage('ja')" class="lang d-none" style="padding: 5px"><img style="width: 25px ;"
            src="img/img-item-vimass-2022/co/ja.jpg" />
        </a>

        <span class="clickShow" style="color: #303038; cursor: pointer; margin: auto"><i class="fa fa-ellipsis-h"
            aria-hidden="true"></i></span>

      </div>
      <a id="urlHome" href="/" style="margin: 0 10px"><img style="width: 35px; height: 35px"
          src="img/home-icon-white-8.jpg" />
      </a>
    </div>
  </header>
  <div class="wrapper row3">
    <main class="hoc container-fluid clear bv">
      <div v-show="activeThietBi" class="min-h--500p">
        <MainSanPham />
      </div>
      <div v-if="activePhi" class="min-h--500p">
        <PhiDichVuVer2 />
      </div>
      <!-- gioi thieu -->
      <div id="gioiThieu" v-show="showGioiThieu" style="min-height: 500px" class="padding-top15">
        <div class="title-bai-viet" v-html="titleGioiThieu"></div>
        <div v-html="contentGioiThieu"></div>
      </div>

      <!-- gioi thieu -->
      <div id="taiTro" v-show="showTaiTro" style="min-height: 500px" class="padding-top15">
        <div class="title-bai-viet" v-html="titleTaiTro"></div>
        <div v-html="contentTaiTro"></div>
      </div>
      <!-- tieu hoc-->
      <div id="BenhVienTinh" v-show="showBenhVienTinh" style="min-height: 500px; background-image: none !important"
        class="padding-top15">
        <div class="title-bai-viet" v-html="titleBenhVienTinh"></div>
        <div v-html="contentBenhVienTinh"></div>
      </div>
      <!-- BenhVienHuyen -->
      <div id="BenhVienHuyen" v-show="showBenhVienHuyen" style="min-height: 500px; background-image: none !important"
        class="padding-top15">
        <div class="title-bai-viet" v-html="titleBenhVienHuyen"></div>
        <div v-html="contentBenhVienHuyen"></div>
      </div>
      <!-- CoSoYTeXa -->
      <div id="CoSoYTeXa" v-show="showCoSoYTeXa" style="min-height: 500px; background-image: none !important"
        class="padding-top15">
        <div class="title-bai-viet" v-html="titleCoSoYTeXa"></div>
        <div v-html="contentCoSoYTeXa"></div>
      </div>

      <!-- LIEN HE -->
      <div id="lienhe" v-show="showLienHe" style="min-height: 500px; background-image: none !important">
        <div class="title-bai-viet" v-html="titleLienHe"></div>
        <div v-html="contentLienHe"></div>
      </div>

    </main>
  </div>
  <FooterView></FooterView>
</template>
<script>
import FooterView from "@/views/Vimass/Footer/FooterView.vue";
import { languages } from "@/components/languages";
import { apiChiTietBaiViet } from "@/components/listService";
import PhiDichVuVer2 from "../MainBaiVietCon/ThietBiVaDichVu/DichVu/PhiDichVuVer2.vue";
import axios from "axios";
import MainSanPham from "../MainBaiVietCon/MainSanPham.vue";
// import { vmCrop } from "@/components/axiosVM";

export default {
  components: {
    FooterView, MainSanPham,
    PhiDichVuVer2,
  },
  data() {
    return {
      activeTab: "taiTro",
      isMenuVisible: false,
      currentLanguage: languages.vi,
      lang: "",
      base64: "",
      base64Title: "",

      //show
      showGioiThieu: false,
      showBenhVienTinh: false,
      showBenhVienHuyen: false,
      showCoSoYTeXa: false,
      showLienHe: false,
      showTaiTro: true,

      //active tab
      isActiveGioiThieu: false,
      isActiveBenhVienTinh: false,
      isActiveBenhVienHuyen: false,
      isAcitveCoSoYTeXa: false,
      isActiveLienHe: false,
      isActiveTaiTro: true,

      //title
      titleGioiThieu: "",
      titleBenhVienTinh: "",
      titleBenhVienHuyen: "",
      titleCoSoYTeXa: "",
      titleLienHe: "",
      titleTaiTro: "",

      //content
      contentGioiThieu: "",
      contentBenhVienTinh: "",
      contentBenhVienHuyen: "",
      contentCoSoYTeXa: "",
      contentLienHe: "",
      contentTaiTro: "",

      hasMounted: false,

      activeThietBi: false,
      activePhi: false,
    };
  },
  mounted() {
    if (window.innerWidth <= 768) {
      this.isMenuVisible = false;
    } else {
      this.isMenuVisible = true;
    }
    if (!this.hasMounted) {
      this.hasMounted = true;
      this.lang = localStorage.getItem("languages") || "vi";
      const titleMap = {
        vi: "Vimass.vn - Thiết bị thiết yếu",
        en: "Vimass.vn - Smart public services",
        cn: "Vimass.vn - Smart public services",
      };
      document.title = titleMap[this.lang] || "Vimass.vn - Thiết bị thiết yếu";

      // this.performPostRequest("1752549940885h0Sxh", "gioiThieu", this.lang);
      document.getElementById("urlCTThiDiem")
        .setAttribute("href", this.lang + "/thietbithietyeu#thietbithietyeu");
      document.getElementById("urlCTTaiTro")
        .setAttribute("href", this.lang + "/thietbithietyeu#benhvien/chuongtrinhtaitro");
      document.getElementById("urlBenhVienTinh")
        .setAttribute("href", this.lang + "/thietbithietyeu#benhvien/benhvientinh");
      document.getElementById("urlBenhVienHuyen")
        .setAttribute("href", this.lang + "/thietbithietyeu#benhvien/benhvienhuyen");
      document
        .getElementById("urlThietBi")
        .setAttribute("href", this.lang + "/thietbithietyeu#thietbi");
      document
        .getElementById("urlDichVu")
        .setAttribute("href", this.lang + "/thietbithietyeu#dichvu");

      const hash = window.location.hash;
      if (hash && hash.includes("#thietbithietyeu")) {
        this.changeTab("ThietBi");
      }
      else if (hash && hash.includes("#thietbi")) {
        this.changeTab("ThietBi");
      } else if (hash && hash.includes("#dichvu")) {
        this.changeTab("DichVu");
      } else {
        // Nếu không phù hợp với bất kỳ tab nào, mặc định hiển thị tab gioiThieu
        this.changeTab("ThietBi");
      }


    }
  },
  created() {
    const savedLanguage = localStorage.getItem("languages") || "vi";
    if (savedLanguage && languages[savedLanguage]) {
      this.currentLanguage = languages[savedLanguage];
    }
  },
  methods: {
    changeLanguage(lang) {
      this.currentLanguage = languages[lang];
      localStorage.setItem("languages", lang);
      const langReload = localStorage.getItem("languages");
      window.location.href = "/" + langReload + "/thietbithietyeu" + window.location.hash;
    },

    async performPostRequest(id, section) {
      this.lang = localStorage.getItem("languages") || "vi";

      try {
        // Thực hiện POST request
        const response = await axios.post(
          apiChiTietBaiViet,
          {
            id: id,
            langId: "0",
          },
        );
        const data = response.data.result;
        this.base64 = data[`content_${this.lang}`];
        this.base64Title = data[`title_${this.lang}`];

        var title = atob(this.base64Title);
        var decodedString = atob(this.base64);

        // Store content separately for each section
        if (section === "gioiThieu") {
          this.titleGioiThieu = decodeURIComponent(escape(title));
          this.contentGioiThieu = decodeURIComponent(escape(decodedString));
        } else if (section === "taiTro") {
          this.titleTaiTro = decodeURIComponent(escape(title));
          this.contentTaiTro = decodeURIComponent(escape(decodedString));
        } else if (section === "BenhVienTinh") {
          this.titleBenhVienTinh = decodeURIComponent(escape(title));
          this.contentBenhVienTinh = decodeURIComponent(escape(decodedString));
        } else if (section === "BenhVienHuyen") {
          this.titleBenhVienHuyen = decodeURIComponent(escape(title));
          this.contentBenhVienHuyen = decodeURIComponent(escape(decodedString));
        } else if (section === "CoSoYTeXa") {
          this.titleCoSoYTeXa = decodeURIComponent(escape(title));
          this.contentCoSoYTeXa = decodeURIComponent(escape(decodedString));
        } else if (section === "lienhe") {
          this.titleLienHe = decodeURIComponent(escape(title));
          this.contentLienHe = decodeURIComponent(escape(decodedString));
        }
      } catch (error) {
        console.error("Error:", error);
      }
    },
    toggleMenu() {
      this.isMenuVisible = !this.isMenuVisible;
    },
    changeTab(tab) {
      this.lang = localStorage.getItem("languages") || "vi";
      if (window.innerWidth <= 768) {
        this.isMenuVisible = false;
      }
      // Tạo một đối tượng để lưu trạng thái của các tab
      const tabStates = {
        gioiThieu: false,
        taiTro: false,
        BenhVienTinh: false,
        BenhVienHuyen: false,
        CoSoYTeXa: false,
        lienhe: false,
        ThietBi: false,
        DichVu: false,
      };

      // Thiết lập trạng thái cho tab được chọn
      tabStates[tab] = true;

      // Gọi hàm performPostRequest với các tham số tương ứng
      this.performPostRequest(this.getPostId(tab), tab, this.lang);

      // Cập nhật giá trị activeTab
      this.activeTab = tab;

      // Cập nhật các biến show dựa trên trạng thái của các tab
      this.showGioiThieu = tabStates.gioiThieu;
      this.showTaiTro = tabStates.taiTro;
      this.showBenhVienTinh = tabStates.BenhVienTinh;
      this.showBenhVienHuyen = tabStates.BenhVienHuyen;
      this.showCoSoYTeXa = tabStates.CoSoYTeXa;
      this.showLienHe = tabStates.lienhe;
      this.activeThietBi = tabStates.ThietBi;
      this.activePhi = tabStates.DichVu;
    },

    getPostId(tab) {
      // Sử dụng một đối tượng để ánh xạ tab với id của bài viết tương ứng
      const postIdMap = {
        gioiThieu: "1752549940885h0Sxh",
        taiTro: "1752549940885h0Sxh",
        BenhVienTinh: "1752549940885h0Sxh",
        BenhVienHuyen: "1752549940885h0Sxh",
        CoSoYTeXa: "1752549940885h0Sxh",
        lienhe: "1752549940885h0Sxh",
      };

      return postIdMap[tab];
    },
  },
};
</script>